import React from "react";
import Box from "@mui/material/Box";
import { useAppSelector, useAppDispatch } from "../../../framework/customStore";
import { SectionHeader } from "../../layout/sectionHeader";
import { MonitorViewVehicles } from "./monitorViewVehicles";
import { MonitorViewWorkShifts } from "./monitorViewWorkShifts";
import { MonitorViewSidebarProps } from "../../../models/monitorView/monitorViewTypes";
import { TabsEnum } from "../monitorViewUtils";
import { MonitorViewEmployees } from "./monitorViewEmployees";
import SidebarHeader from "./sidebarHeader";
import {
    setSelectedEmployeeId,
    setSidebarTitle,
    toggleWorkShiftView,
    setSelectedWorkShift,
} from "../../../store/monitorViewSlice";
import { getCurrentWorkShift } from "../../../services/workShiftService";
import { handleVehicleSelect } from "../monitorViewUtils";
import { MonitorViewVehicle } from "./monitorViewVehicle";

export const MonitorViewSidebar = ({
    workShiftSidebarProps,
    vehicleSidebarProps,
    employeeSidebarProps,
    activeEmployeesAndVehicles
}: MonitorViewSidebarProps) => {
    const dispatch = useAppDispatch();

    const {
        activeTab: tab,
        sidebarTitle,
        isWorkShiftView,
        isVehicleDetailView,
        vehicles
    } = useAppSelector((state) => state.monitorView);

    const { activeVehicles, activeEmployees } = activeEmployeesAndVehicles;

    const onEmployeeSelect = async (employeeId: string) => {
        if (employeeId) {
            dispatch(setSelectedEmployeeId(employeeId));
            const workShift = await getCurrentWorkShift(employeeId, true);
            if (workShift) {
                dispatch(setSelectedWorkShift(workShift));
                dispatch(setSidebarTitle(workShift?.workShiftTimeSlots?.[0]?.employeeName || ""));
                dispatch(toggleWorkShiftView());
            }
        }
    };

    const onVehicleSelect = (vehicleId: string) => {
        handleVehicleSelect(
            vehicleId,
            vehicles,
            isVehicleDetailView,
            dispatch
        );
    };

    return (
        <Box width={375} height="100%" display="flex" flexDirection="column">
            <SectionHeader>
                <SidebarHeader
                    workShiftSidebarProps={workShiftSidebarProps}
                    header={sidebarTitle}
                    activeVehicles={activeVehicles}
                    activeEmployees={activeEmployees}
                />
            </SectionHeader>

            <Box sx={{ overflowY: "auto", paddingTop: 1 }}>
                {isWorkShiftView ? (
                    <MonitorViewWorkShifts {...workShiftSidebarProps} />
                ) : isVehicleDetailView ? (
                    <MonitorViewVehicle />
                ) : (
                    tab === TabsEnum.VEHICLES ? (
                        <MonitorViewVehicles {...vehicleSidebarProps} onSelect={onVehicleSelect} />
                    ) : (
                        <MonitorViewEmployees {...employeeSidebarProps} onSelect={onEmployeeSelect} />
                    )
                )}
            </Box>
        </Box>
    );
};
